export const ConciliacaoModal = {
  importarArquivo: 'importarArquivo',
  acrecimoDesconto: 'acrecimoDesconto',
  pesquisaContaPagar: 'pesquisaContaPagar',
  pesquisaContaReceber: 'pesquisaContaReceber',
  cadastrarContaPagarModal: 'cadastrarContaPagarModal',
  cadastroContaReceberModal: 'cadastroContaReceberModal',
  cadastrarTransferencia: 'cadastrarTransferencia',
  regrasAutomaticas: 'regrasAutomaticas',
  cadastrarRegrasAutomaticas: 'cadastrarRegrasAutomaticas',
  pesquisaTransferencia: 'pesquisaTransferencia',
};
